/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_05_NumInputs */

const en_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const de_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const fr_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const es_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const it_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const nl_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const pl_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const fi_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const da_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

const sv_landing_section_05_num = /** @type {(inputs: Landing_Section_05_NumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05`)
};

/**
* | output |
* | --- |
* | "05" |
*
* @param {Landing_Section_05_NumInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_05_num = /** @type {((inputs?: Landing_Section_05_NumInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_05_NumInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_05_num(inputs)
	if (locale === "fr") return fr_landing_section_05_num(inputs)
	if (locale === "es") return es_landing_section_05_num(inputs)
	if (locale === "it") return it_landing_section_05_num(inputs)
	if (locale === "nl") return nl_landing_section_05_num(inputs)
	if (locale === "pl") return pl_landing_section_05_num(inputs)
	if (locale === "fi") return fi_landing_section_05_num(inputs)
	if (locale === "da") return da_landing_section_05_num(inputs)
	if (locale === "sv") return sv_landing_section_05_num(inputs)
	return en_landing_section_05_num(inputs)
});